import { Subject } from "rxjs";

/**
 * @class MessagingTopic
 * @description Class used for building communication topics between components.
 * @author Allan A. Chua
 * @version 1.0
 * @since November 08, 2018
 */
export default class MessagingTopic {
  constructor() {
    this.subject = new Subject();
    this.observable = this.subject.asObservable();
  }

  /**
   * @function publish
   * @description Method used for broadcasting messages to listening parties.
   * @param {Object} msgObj Message that will be passed around
   */
  publish(msgObj = {}) {
    this.subject.next(msgObj);
  }

  /**
   * @function subscribe
   * @description Method used for listening for messages issued by publishers.
   * @param {Function} callback Method that will be invoked once a message is published on the pipe.
   */
  subscribe(callback) {
    this.observable.subscribe(callback);
  }

  unsubscribe() {
    this.subject.observers.forEach((obs) => obs.unsubscribe());
  }
}
